import React, {Component} from 'react'
import newsPlaceholder from "../assets/img/news-placeholder.png";
import CustomImage from "./CustomImage";

export default class LinkPreview extends Component {

    render() {
        if (!this.props.link ||
            !this.props.title ||
            this.props.hide === true) return ""

        let {order, link, image, title, siteName} = this.props;

        return (
            <div className="row link-preview">
                <div className="col-2 margin-auto">
                    <CustomImage className="preview-img"
                                 key={order + "-image"}
                                 src={image}
                                 emptyAvatar={newsPlaceholder}/>
                </div>
                <div className="col-10 pl-0">
                    <div className="preview-content media-body">
                        <strong className="site-name">{siteName}</strong>
                        <label className="link-title">{title}</label>
                        <a href={link}
                           target="_blank"
                           className="target-link">
                            {link}
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}